import * as React from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import {
	asInternalTeamsSlice,
	getInternalTeamId,
	getInternalTeamName,
	internalTeamsThunkForRole,
	INTERNAL_TEAMS_PAGINATION,
	INTERNAL_TEAMS_TC,
	INTERNAL_TEAM_FILTERS,
} from './internalTeams';
import { withUserType } from '../withUserType';

// Multi-select over the buyer's internal teams — the suppliers that are private to
// this buyer company, i.e. exactly what the Internal Teams tab of the private
// network lists. Same list, same endpoint: buyer_supplier_relationships filtered
// to isInternalTeam, so nothing new is fetched or cached on its own.
//
// The value is the relationship's supplierFacilityId, which is both the id work
// orders are assigned to and what a project stores in supplierFacilityIds.

const InternalTeamSelect: React.FC<any> = ({
	supplierPrivateNetworks,
	fetchInternalTeams,
	value,
	onChange,
	placeholder = 'Search for an internal team',
	style,
	disabled,
}) => (
	<OWAsyncSelect
		mode="multiple"
		stateSlice={asInternalTeamsSlice(supplierPrivateNetworks)}
		targetCollectionName={INTERNAL_TEAMS_TC}
		additionalFilters={INTERNAL_TEAM_FILTERS}
		initialPagination={INTERNAL_TEAMS_PAGINATION}
		// Reopening the dropdown clears any leftover search, so the full list is back
		// and a selected team can never sit there without its label.
		resetSearchWhenOpenSelect={true}
		value={value}
		onChange={onChange}
		placeholder={placeholder}
		disabledPlaceholder="No internal teams yet"
		style={style}
		disabled={disabled}
		valueAccessor={getInternalTeamId}
		labelAccessor={getInternalTeamName}
		// Deliberately a no-op: a buyer has at most a handful of internal teams, so the
		// first page holds every one of them and preselected chips resolve their labels
		// from it. The list endpoint filters by a single supplierFacilityId anyway, so
		// hydrating N preselected teams would mean N requests for nothing.
		fetchMultiple={() => {}}
		fetchData={(searchText, targetCollectionName, pagination, sorting, filters) =>
			fetchInternalTeams(
				// Free-text search on this list is the facility alias.
				searchText ? { supplierFacilityAlias: searchText } : {},
				targetCollectionName,
				pagination,
				sorting,
				filters
			)
		}
		renderRecord={(relationship) => (
			<Select.Option key={getInternalTeamId(relationship)} value={getInternalTeamId(relationship)}>
				{getInternalTeamName(relationship)}
			</Select.Option>
		)}
	/>
);

const mapStateToProps = (state) => ({
	supplierPrivateNetworks: state.supplier_private_networks,
});

const mapDispatchToProps = (dispatch, ownProps: any) => ({
	fetchInternalTeams: (params, targetCollectionName, pagination, sorting, filters) =>
		dispatch(
			internalTeamsThunkForRole(ownProps.userType)(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters
			)
		),
});

export default withUserType(connect(mapStateToProps, mapDispatchToProps)(InternalTeamSelect));
